<template>
  <div class="bg-[#F2F6FA] h-full">
    <div class="flex flex-col items-center justify-center w-full pb-20">
      <section
        class="flex flex-col items-center w-full justify-center "
      >
        <div
          class="flex items-center justify-between md:mt-5 mb-2 md:mb-0 mt-2 px-2 md:px-0 w-full"
        >
          <div class="items-center gap-2 px-4 mt-5 -ml-2 d-flex">
            <v-icon
              class="cursor-pointer w-6 md:w-[28px] text-primary"
              size="28"
            >
              mdi-web
            </v-icon>
            <div class="flex items-center gap-1">
              <p class="text-base md:text-[22px] font-bold">Microsite & Landing Page Configurations</p>
            </div>
          </div>
        </div>
        <div class="min-h-screen w-full overflow-x-hidden rounded-2xl mt-5 main-website-landing">
          <v-tabs v-model="activeTab">
            <v-tab value="landing-page">
              <v-icon left small class="mr-2">mdi-store</v-icon>
              Landing Page
            </v-tab>
            <v-tab value="store-locator">
              <v-icon left small class="mr-2">mdi-map-marker</v-icon>
              Store Locator
            </v-tab>
            <v-tab value="blog-management">
              <v-icon left small class="mr-2">mdi-post</v-icon>
              Blog Management
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab" class="rounded-b-2xl">
            <!-- Landing Page Tab -->
            <v-tab-item :value="0">
              <div class="pa-4">
                <IndividualStoreConfigurations />
              </div>
            </v-tab-item>

            <!-- Store Locator Tab -->
            <v-tab-item :value="1">
              <div class="pa-4">
                <StoreLocatorConfigurations />
              </div>
            </v-tab-item>

            <!-- Blog Management Tab -->
            <v-tab-item :value="2">
              <div class="pa-4">
                <BlogManagement />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import IndividualStoreConfigurations from "./IndividualStoreConfigurations.vue";
import StoreLocatorConfigurations from "./StoreLocatorConfigurations.vue";
import BlogManagement from "./BlogManagement.vue";

export default {
  name: "Website",
  components: {
    IndividualStoreConfigurations,
    StoreLocatorConfigurations,
    BlogManagement,
  },
  data() {
    return {
      activeTab: 0,
      tabs: {
        "landing-page": 0,
        "individual-store-configurations": 0,
        "store-locator": 1,
        "store-locator-configurations": 1,
        "blog-management": 2,
      },
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (this.tabs[tab] !== undefined) {
          this.activeTab = this.tabs[tab];
        }
      },
    },
    activeTab(newVal) {
      if(typeof newVal === 'number') {
        const tabName = Object.keys(this.tabs).find(key => this.tabs[key] === newVal);
        if (tabName) {
          this.modifyUrlParams("tab", tabName);
        }
      } else {
        this.modifyUrlParams("tab", newVal);
      }
    },
  },
  async created() {
    if (this.$route.query.tab) {
      this.activeTab = this.tabs[this.$route.query.tab];
    }
  },
  methods: {
    modifyUrlParams(param, value) {
      // Check if the current value in the URL is already the same
      if (this.$route.query[param] === value) {
        return; // Skip redundant navigation
      }
      // Only update the URL if the value is different
      this.$router.replace({ query: { ...this.$route.query, [param]: value } });
    },
  },
};
</script>

<style scoped>
.main-website-landing {
  background: white;
  margin: 0 16px;
}

.tab-icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  vertical-align: middle;
}
</style> 